import axios from "../axios-auth";

export const accountPayableDetailService = {
    getAccountPayableDetailList
};

function getAccountPayableDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
   
    if (searchParams.accountPayableId) {
        params["accountPayableId"] = searchParams.accountPayableId;
    }
    return axios.get("/auth/account-payable-details", { params });
}
